export const FILTER_IDS = {
  ALL_RESULTS: 'all_results',
  CATEGORY: 'category',
  CONDITION: 'condition',
  LOCATION: 'location',
  LEADERSHIP: 'leadership_bio',
  ONLINE_SCHEDULING_TYPE: 'online-scheduling',
  PAGE: 'page',
  PROVIDER: 'provider',
  RESEARCH: 'research',
  SEARCH: 'search',
  SERVICE: 'service',
  SPECIALTY: 'specialty',
  TREATMENT: 'treatment',
  BLOG: 'blog',
  BLOG_CATEGORY: 'blog-category'
}

export const BREAKPOINTS = {
  DESKTOP: 1024,
}

export const SearchApiResultsConstants = {
  TOTAL_ITEMS: 'total_items',
  TOTAL_PAGES: 'total_pages',
  ITEMS_PER_PAGE: 'items_per_page',
}

export const SessionStorageKeys = {
  GLOBAL_SEARCH_TERM: 'globalSearchTerm',
  PROVIDERS_LOCATIONS_SEARCH_TERM: 'providersLocationSearchTerm',
}

export const ResultType = {
  PROVIDERS: 'provider',
  LOCATIONS: 'location',
}

export const AppointmentTypes = {
  TELEMEDICINE: 'Telemedicine',
  IN_PERSON: 'InPerson'
};

export const ONLINE_SCHEDULING_TYPE = {
  IN_PERSON: 'in-person',
  TELEMEDICINE: 'telemedicine',
  IN_PERSON_OR_TELEMEDICINE: 'in-person-or-telemedicine',
};

export const ZERO_INDEX_EQUALIZER = 1;

export const LOG_INTO_MYCHART_RESULT_INDEX = 2;
